import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { UserService } from '@teem/services/user.service';
import { StoreInformationService } from '@teem/services/store-information.service';
import { LoaderService } from '@teem/services/loader.service';
import { country as CountryApi } from '@teem/core/constants/api';
import { messages as i18n } from '@teem/constants/messages';

declare var $: any;

@Component({
	selector: 'app-add-city-modal',
	templateUrl: './add-city-modal.component.html'
})
export class AddCityModalComponent implements OnInit {
	countryListApi: string = CountryApi.endPoint;
	regionListApi: string = CountryApi.regions;
	cityListApi: string = CountryApi.cities;
	submitted: boolean = false;
	addCityForm: FormGroup;
	@Input() userInfo;
	districts = [];
	cities = [] ;


	constructor(
		private fb: FormBuilder,
		public activeModal: NgbActiveModal,
		private storeInformationService: StoreInformationService,
		private userService: UserService,
		private loaderService: LoaderService,
		private el: ElementRef

	) {
		this.createAddCityFormGroup();
	}

	ngOnInit(): void {
	}


	createAddCityFormGroup() {
		this.addCityForm = this.fb.group({
			region_id: [null, Validators.required],
			city: [null],
			city_id: [null, Validators.required],
			district_id: [null, Validators.required]
		});
	}

	onChangeRegion(item) {
		let region = item.id;
		if (region) {
			this.loaderService.startLoading();
			this.storeInformationService.getCities(region).subscribe((data: any) => {
				this.cities = data;
				this.loaderService.stopLoading();
			}, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			})
		}
	}

	onChangeCity(item) {
		let city = item.id;
		 this.addCityForm.controls.city.setValue(item.name);
		if (city) {
			this.loaderService.startLoading();
			this.storeInformationService.getDistricts(city).subscribe((data: any) => {
				this.districts = data;
				this.loaderService.stopLoading();
			}, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			})
		}
	}


	get f() {
		return this.addCityForm.controls;
	}

	onSubmit() {
		this.submitted = true;
		if (this.addCityForm.valid) {

			let fd = this.addCityForm.value;
			this.loaderService.startLoading();

			this.userService.updateCity(fd)
				.subscribe(
					(res: any) => {
						this.loaderService.stopLoading();

						this.addCityForm.reset();
						this.activeModal.close(res);

						Swal.fire(i18n.done, i18n.dashboard.city_update_successfully, 'success');
					},
					(err) => {
						this.loaderService.stopLoading();
						if (err.status === 422) {
							if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
								let validationErrors = err.error.errors;
								Object.keys(validationErrors).forEach((prop) => {
									this.addCityForm.get(prop)?.setErrors({
										serverError: validationErrors[prop]
									})
								})
							}
						}

						Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
					}
				)
			this.submitted = false;
		}
	}
}
